<!--  -->
<template>
  <div class="social-awareness">
    <div class="row-content">
      <h2 class="title">Overview</h2>
      <p class="content">On LivU, you can meet new people and connect with friends, but our app works best when everyone understands how to be respectful and is aware of how their behavior affects other community members.</p>
    </div>
    <dl class="switch-list">
      <dt @click="switchContent($event)">Women’s Online Safety</dt>
      <dd>
        <p>Women are more likely to use the internet to enrich their relationships compared to men. Unfortunately, young women between 18-24, are more likely to experience severe types of harassment at disproportionality higher levels than any other demographic.</p>
        <p>In addition to following our <router-link to="/safety-tips">Safety Tips</router-link>, we advise that women take extra precaution when using any online social app. While you should feel empowered by LivU as a social tool, you should be cautious of how much information you share, and proactively avoid those who make you feel uncomfortable, specifically by blocking those community members in your settings.</p>
        <p>We take these issues very seriously and urge women in our community to report any users they feel are specifically targeting to harass women. These reports may result in the offender being banned if found to be violating our community guidelines.</p>
        <p>In many countries, there are specific helpline numbers women may call if faced with verbal or physical harassment. For specific help with an issue you may be facing, reach out to your government or national women’s helpline for further advice.</p>
        <p>Useful references</p>
        <p>• <a href="https://www.womensaid.org.uk/" target="_blank">Women’s Aid</a><br>• <a href="https://www.womenagainstabuse.org/" target="_blank">Women Against Abuse</a><br>• <a href="https://ec.europa.eu/justice/saynostopvaw/helpline.html" target="_blank">European Women’s Helpline Directory</a></p>
      </dd>
    </dl>
    <dl class="switch-list">
      <dt @click="switchContent($event)">Nudity & Sexting</dt>
      <dd>
        <p>Flirting, expressing sexual feelings and having relationships increasingly happens online.</p>
        <p>Some people might think that sharing nudes (often called sexting) will get people's attention or make them more popular.</p>
        <p>In some cases, they might be pressured into it by romantic partners, friends or even complete strangers and not realize that sharing personal images could put them at risk of sexual exploitation.</p>
        <p>They might find that their photos and videos are passed on to other people without their consent. Known as revenge porn or sextortion.</p>
        <p>Separately, in breach of our <router-link to="/community-guidelines">Community Guidelines</router-link>, some users on the platform might try to voluntary expose themselves without the consent of the other users watching.</p>
        <p>To help protect our users, all nude and sexual images are not allowed during LivU’s matching phase and we have deployed specific artificial intelligence technology along with human reporting tools to detect and stop the streaming session as quickly as possible.<br><router-link to="/safety-tools">Learn more about our safety technology.</router-link></p>
      </dd>
    </dl>
    <dl class="switch-list">
      <dt @click="switchContent($event)">No Underage Users</dt>
      <dd>
        <p>LivU is a platform for adults only and users under 18 years old are strictly forbidden from joining the app.</p>
        <p>As a parent, if you see your child using LivU, you can inform us by making a report and sending us a message; we will take immediate action to shut down the account.</p>
        <p>Useful websites<br>• <a href="https://www.childnet.com/" target="_blank">Childnet International</a><br>• <a href="https://www.iwf.org.uk/" target="_blank">Internet Watch Foundation</a></p>
      </dd>
    </dl>
    <dl class="switch-list">
      <dt @click="switchContent($event)">Discrimination</dt>
      <dd>
        <p>We have a zero-tolerance policy towards conduct we determine to be discriminatory. Users who discriminate against another community member based on characteristics including age, race, gender identity, disability, marital status, nationality, religion, sex, sexual orientation, or any other trait protected under international and local law, may receive a warning and have their accounts removed.</p>
        <p>While we can’t control whether you will make a special connection with everyone, if you find another community member to be discriminating against you in a manner you deem unacceptable, please report the user immediately to our team who will be able to investigate further. </p>
      </dd>
    </dl>
    <dl class="switch-list">
      <dt @click="switchContent($event)">Fake Profiles & Scams</dt>
      <dd>
        <p>On social networks, people sometimes pretend to be someone they are not. They set up fake profiles and try to dupe other users into becoming friends for the wrong reasons.</p>
        <p>Catfishing and other online scams can be disconcerting and upsetting for users and could even put them at risk of identity theft and sexual exploitation.</p>
        <p>We want to know the real identity of all our community members as we believe it makes the LivU community safer. We shut down fake profiles and deal with scams as soon as we know about them.</p>
        <p>Useful websites</p>
        <p>
          • <a href="https://www.connectsafely.org/" target="_blank">ConnectSafely</a><br>
          • <a href="https://www.getcybersafe.gc.ca/index-eng.aspx" target="_blank">Get Cyber Safe</a><br>
          • <a href="https://www.getsafeonline.org/privacy-policy/" target="_blank">Get Safe Online</a><br>
          • <a href="https://www.internetmatters.org/" target="_blank">Internet Matters</a><br>
          • <a href="https://www.netsafe.org.nz/" target="_blank">Netsafeb</a><br>
          • <a href="https://www.esafety.gov.au/" target="_blank">Office of the eSafety Commissioner</a><br>
        </p>
      </dd>
    </dl>
    <dl class="switch-list">
      <dt @click="switchContent($event)">Harmful & Illegal Content</dt>
      <dd>
        <p>Violence, drugs, racism, homophobia, violent extremism, pornography, gambling, criminal activity... users might come across things online that they should not see. It could be inaccurate, offensive or even unlawful.</p>
        <p>We do not tolerate harmful and illegal content on LivU and take such content down as soon as we become aware of it. If the content could be breaking the law, we refer it to the authorities.</p>
      </dd>
    </dl>
    <dl class="switch-list">
      <dt @click="switchContent($event)">Inappropriate language</dt>
      <dd>
        <p>It is not uncommon for users to test boundaries with the language they use on the internet, whether it’s swearing on chats or using emojis that have hidden sexual meaning.</p>
        <p>LivU has deployed an advanced algorithm to automatically monitor certain inappropriate words used by users when chatting and take action where appropriate.</p>
        <p>During the matching phase, if a user uses a blacklisted word the message which contained this specific word will not be sent to the receiving party (backlisted words include words with sexual or inappropriate connotations).</p>
      </dd>
    </dl>
    <dl class="switch-list">
      <dt @click="switchContent($event)">Self-esteem</dt>
      <dd>
        <p>Any person surfing on internet might experience body shaming, bullying and other forms of humiliation online.</p>
        <p>In a society of ‘photoshopped models’ and virtual filters, there’s even more pressure on internet users to look and behave a certain way. Be cautious of the effects social media may be having you or your loved ones’ mental health.</p>
        <p>Useful links:<br>• <a href="https://www.mind.org.hk/" target="_blank">Mind | Mental Health Organisation</a><br>• <a href="https://youngminds.org.uk/" target="_blank">Young Minds | Useful Tips</a></p>
      </dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: 'online-social-awareness',
  data () {
    return {
    }
  },
  methods: {
    switchContent (e) {
      const el = e.target
      el.className === 'on' ? el.className = '' : el.className = 'on'
    }
  }
}

</script>
<style lang='scss' scoped>
@import '@/assets/style/vars.scss';
@media (min-width: 750px) {
  .social-awareness {
    width: 1000px;
    margin: 0 auto;
    padding-bottom: 100px;
    .row-content {
      width: 970px;
      margin: 40px auto 90px auto;
      .title {
        font-size: 40px;
        line-height: 47px;
        font-weight: bold;
        color: #333;
        margin-bottom: 25px;
      }
      .content {
        color: #6B6B6B;
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 15px;
      }
    }
    .switch-list {
      margin-bottom: 20px;
      &>dt {
        width: 100%;
        height: 60px;
        background-color: #FAFAFA;
        color: #333;
        font-size: 24px;
        font-weight: bold;
        padding: 0 20px;
        line-height: 60px;
        position: relative;
        text-align: left;
        &::after {
          content: '';
          width: 32px;
          height: 32px;
          position: absolute;
          top: 15px;
          right: 20px;
          background: url('../assets/images/xia.png') no-repeat;
          transition: all .3s linear;
        }
        &.on::after {
          transform: rotate(180deg)
        }
        &.on + dd {
          display: block;
        }
      }
      &>dd {
        font-size: 24px;
        color: #5E5E5E;
        line-height: 28px;
        text-align: left;
        display: none;
        padding-bottom: 15px;
        p {
          margin-top: 25px;
        }
      }
    }
  }
}
@media (max-width: 750px) {
  .social-awareness {
    padding: 10px 25px;
    .row-content {
      padding: 20px 0 30px 0;
      .title {
        font-size: 22px;
        line-height: 26px;
        font-weight: bold;
        color: #333;
        margin-bottom: 18px;
      }
      .content {
        color: #6B6B6B;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 15px;
      }
    }
    .switch-list {
      margin-bottom: 10px;
      &>dt {
        width: 100%;
        height: 32px;
        background-color: #FAFAFA;
        color: #333;
        font-size: 14px;
        font-weight: bold;
        padding: 0 15px;
        line-height: 32px;
        position: relative;
        text-align: left;
        &::after {
          content: '';
          width: 16px;
          height: 16px;
          position: absolute;
          top: 9px;
          right: 15px;
          background: url('../assets/images/xia.png') no-repeat;
          background-size: 100%;
          transition: all .3s linear;
        }
        &.on::after {
          transform: rotate(180deg)
        }
        &.on + dd {
          display: block;
        }
      }
      &>dd {
        font-size: 14px;
        color: #5E5E5E;
        line-height: 18px;
        text-align: left;
        display: none;
        padding-bottom: 15px;
        p {
          margin-top: 17px;
        }
      }
    }
  }
}
</style>
